
// Predefined palettes
export const THEME_COLORS = [
    {
        name: 'Original Green', value: 'green',
        variables: {
            '--primary-50': '240 253 244',
            '--primary-100': '220 252 231',
            '--primary-200': '187 247 208',
            '--primary-300': '134 239 172',
            '--primary-400': '74 222 128',
            '--primary-500': '34 197 94',
            '--primary-600': '22 163 74',
            '--primary-700': '21 128 61',
            '--primary-800': '22 101 52',
            '--primary-900': '20 83 45',
            '--primary-950': '5 46 22',
        }
    },
    {
        name: 'Ocean Blue', value: 'blue',
        variables: {
            '--primary-50': '239 246 255',
            '--primary-100': '219 234 254',
            '--primary-200': '191 219 254',
            '--primary-300': '147 197 253',
            '--primary-400': '96 165 250',
            '--primary-500': '59 130 246',
            '--primary-600': '37 99 235',
            '--primary-700': '29 78 216',
            '--primary-800': '30 64 175',
            '--primary-900': '30 58 138',
            '--primary-950': '23 37 84',
        }
    },
    {
        name: 'Royal Purple', value: 'purple',
        variables: {
            '--primary-50': '250 245 255',
            '--primary-100': '243 232 255',
            '--primary-200': '233 213 255',
            '--primary-300': '216 180 254',
            '--primary-400': '192 132 252',
            '--primary-500': '168 85 247',
            '--primary-600': '147 51 234',
            '--primary-700': '126 34 206',
            '--primary-800': '107 33 168',
            '--primary-900': '88 28 135',
            '--primary-950': '59 7 100',
        }
    },
    {
        name: 'Rose Red', value: 'rose',
        variables: {
            '--primary-50': '255 241 242',
            '--primary-100': '255 228 230',
            '--primary-200': '254 205 211',
            '--primary-300': '253 164 175',
            '--primary-400': '251 113 133',
            '--primary-500': '244 63 94',
            '--primary-600': '225 29 72',
            '--primary-700': '190 18 60',
            '--primary-800': '159 18 57',
            '--primary-900': '136 19 55',
            '--primary-950': '76 5 25',
        }
    },
    {
        name: 'Amber Orange', value: 'amber',
        variables: {
            '--primary-50': '255 251 235',
            '--primary-100': '254 243 199',
            '--primary-200': '253 230 138',
            '--primary-300': '252 211 77',
            '--primary-400': '251 191 36',
            '--primary-500': '245 158 11',
            '--primary-600': '217 119 6',
            '--primary-700': '180 83 9',
            '--primary-800': '146 64 14',
            '--primary-900': '120 53 15',
            '--primary-950': '69 26 3',
        }
    },
    {
        name: 'Turquoise Teal', value: 'teal',
        variables: {
            '--primary-50': '240 253 250',
            '--primary-100': '204 251 241',
            '--primary-200': '153 246 228',
            '--primary-300': '94 234 212',
            '--primary-400': '45 212 191',
            '--primary-500': '20 184 166',
            '--primary-600': '13 148 136',
            '--primary-700': '15 118 110',
            '--primary-800': '17 94 89',
            '--primary-900': '19 78 74',
            '--primary-950': '4 47 46',
        }
    },
    {
        name: 'Indigo Night', value: 'indigo',
        variables: {
            '--primary-50': '238 242 255',
            '--primary-100': '224 231 255',
            '--primary-200': '199 210 254',
            '--primary-300': '165 180 252',
            '--primary-400': '129 140 248',
            '--primary-500': '99 102 241',
            '--primary-600': '79 70 229',
            '--primary-700': '67 56 202',
            '--primary-800': '55 48 163',
            '--primary-900': '49 46 129',
            '--primary-950': '30 27 75',
        }
    },
    {
        name: 'Hot Pink', value: 'pink',
        variables: {
            '--primary-50': '253 242 248',
            '--primary-100': '252 231 243',
            '--primary-200': '251 207 232',
            '--primary-300': '249 168 212',
            '--primary-400': '244 114 182',
            '--primary-500': '236 72 153',
            '--primary-600': '219 39 119',
            '--primary-700': '190 24 93',
            '--primary-800': '157 23 77',
            '--primary-900': '131 24 67',
            '--primary-950': '80 7 36',
        }
    },
    {
        name: 'Monochrome Slate', value: 'slate',
        variables: {
            '--primary-50': '248 250 252',
            '--primary-100': '241 245 249',
            '--primary-200': '226 232 240',
            '--primary-300': '203 213 225',
            '--primary-400': '148 163 184',
            '--primary-500': '100 116 139',
            '--primary-600': '71 85 105',
            '--primary-700': '51 65 85',
            '--primary-800': '30 41 59',
            '--primary-900': '15 23 42',
            '--primary-950': '2 6 23',
        }
    },
    {
        name: 'Cyan Sky', value: 'cyan',
        variables: {
            '--primary-50': '236 254 255',
            '--primary-100': '207 250 254',
            '--primary-200': '165 243 252',
            '--primary-300': '103 232 249',
            '--primary-400': '34 211 238',
            '--primary-500': '6 182 212',
            '--primary-600': '8 145 178',
            '--primary-700': '14 116 144',
            '--primary-800': '21 94 117',
            '--primary-900': '22 78 99',
            '--primary-950': '8 51 68',
        }
    },
    {
        name: 'Lime Zest', value: 'lime',
        variables: {
            '--primary-50': '247 254 231',
            '--primary-100': '236 252 203',
            '--primary-200': '217 249 157',
            '--primary-300': '190 242 100',
            '--primary-400': '163 230 53',
            '--primary-500': '132 204 22',
            '--primary-600': '101 163 13',
            '--primary-700': '77 124 15',
            '--primary-800': '63 98 18',
            '--primary-900': '54 83 20',
            '--primary-950': '26 46 5',
        }
    },
    {
        name: 'Electric Fuchsia', value: 'fuchsia',
        variables: {
            '--primary-50': '253 244 255',
            '--primary-100': '250 232 255',
            '--primary-200': '245 208 254',
            '--primary-300': '240 171 252',
            '--primary-400': '232 121 249',
            '--primary-500': '217 70 239',
            '--primary-600': '192 38 211',
            '--primary-700': '162 28 175',
            '--primary-800': '134 25 143',
            '--primary-900': '112 26 117',
            '--primary-950': '74 4 78',
        }
    }
];

// Helper to convert Hex to RGB string "r g b"
const hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ?
        `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`
        : '0 0 0';
};

// Start mixing from the hex color to generate shades
// This is a simplified mixer. For production quality, we'd use a library like chroma-js,
// but to avoid deps we'll use a basic tint/shade generator.
const generatePalette = (hex: string) => {
    // Parse base color
    const [r, g, b] = hexToRgb(hex).split(' ').map(Number);

    // Simple mixing function
    const mix = (c1: number, c2: number, weight: number) => Math.round(c1 + (c2 - c1) * weight);
    const tint = (weight: number) => `${mix(r, 255, weight)} ${mix(g, 255, weight)} ${mix(b, 255, weight)}`;
    const shade = (weight: number) => `${mix(r, 0, weight)} ${mix(g, 0, weight)} ${mix(b, 0, weight)}`;

    return {
        '--primary-50': tint(0.95),
        '--primary-100': tint(0.9),
        '--primary-200': tint(0.75),
        '--primary-300': tint(0.6),
        '--primary-400': tint(0.3),
        '--primary-500': `${r} ${g} ${b}`, // Base color
        '--primary-600': shade(0.1),
        '--primary-700': shade(0.25),
        '--primary-800': shade(0.4),
        '--primary-900': shade(0.6),
        '--primary-950': shade(0.8),
    };
};

export const applyTheme = (themeName: string) => {
    const theme = THEME_COLORS.find(t => t.value === themeName);

    if (theme) {
        // Predefined theme
        const root = document.documentElement;
        Object.entries(theme.variables).forEach(([property, value]) => {
            root.style.setProperty(property, value);
        });
        localStorage.setItem('theme_color', themeName);
        localStorage.removeItem('theme_custom_hex'); // Clear custom if picking preset
    } else {
        // Assuming it's a hex code passed directly if passed here
        // But usually applyTheme handles presets. applyCustomTheme is better for custom.
    }
};

export const applyCustomTheme = (hex: string) => {
    const variables = generatePalette(hex);
    const root = document.documentElement;

    Object.entries(variables).forEach(([property, value]) => {
        root.style.setProperty(property, value);
    });

    localStorage.setItem('theme_color', 'custom');
    localStorage.setItem('theme_custom_hex', hex);
};

export const toggleDarkMode = (isDark: boolean) => {
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';
    if (isDark) {
        document.documentElement.classList.add('dark');
        localStorage.setItem('theme_mode', 'dark');
    } else {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme_mode', 'light');
    }
};

export const loadSavedTheme = () => {
    const savedColor = localStorage.getItem('theme_color') || 'green';
    const savedCustomHex = localStorage.getItem('theme_custom_hex');
    const savedMode = localStorage.getItem('theme_mode') === 'dark';

    if (savedColor === 'custom' && savedCustomHex) {
        applyCustomTheme(savedCustomHex);
    } else {
        applyTheme(savedColor);
    }

    toggleDarkMode(savedMode);

    return { color: savedColor, isDark: savedMode, customHex: savedCustomHex };
};
